import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faSearch,
	faShoppingCart,
	faUser,
	faBars,
	faClose,
	faHome,
	faBasketShopping,
	faTag,
	faStar,
	faArrowRight,
	faArrowLeft,
	faShippingFast,
	faUndo,
	faTrash,
	faFileContract,
	faCamera,
	faPen,
	faBell,
	faPowerOff,
	faPlus,
	faSeedling,
	faEnvelope,
	faPhone,
	faDownload,
	faCashRegister,
	faTicket,
	faFileInvoice,
	faBox,
	faShield,
	faCalendar,
	faCheckCircle,
	faEye,
	faUpload,
	faSave,
	faEyeLowVision,
	faBoxesStacked,
	faChevronDown,
	faPills,
	faCalendarAlt,
	faTshirt,
	faSuitcaseRolling,
	faFilter,
	faLock,
	faChevronLeft,
	faChevronRight,
	faEllipsisV,
	faUsers,
	faTimes,
	faDollar,
} from '@fortawesome/free-solid-svg-icons'

interface IconProps {
	icon: string
	size?: 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3x' | '4x' | '5x'
	color?: string
	aria_label?: string
	display?: string
	click?: () => void
}

const Mapping = {
	search: faSearch,
	shopping: faShoppingCart,
	user: faUser,
	users: faUsers,
	bar: faBars,
	close: faClose,
	house: faHome,
	basket: faBasketShopping,
	tag: faTag,
	star: faStar,
	left: faArrowLeft,
	right: faArrowRight,
	return: faUndo,
	shipping: faShippingFast,
	delete: faTrash,
	contract: faFileContract,
	camera: faCamera,
	edit: faPen,
	notifications: faBell,
	off: faPowerOff,
	more: faPlus,
	send: faSeedling,
	email: faEnvelope,
	phone: faPhone,
	download: faDownload,
	cash: faCashRegister,
	ticket: faTicket,
	invoice: faFileInvoice,
	box: faBox,
	shield: faShield,
	calendar: faCalendar,
	check: faCheckCircle,
	view: faEye,
	viewClose: faEyeLowVision,
	upload: faUpload,
	saved: faSave,
	category: faBoxesStacked,
	chevronDown: faChevronDown,
	chevronLeft : faChevronLeft,
	chevronRight : faChevronRight,
	supplements: faPills,
	plans_personalized: faCalendarAlt,
	clothes: faTshirt,
	accessories: faSuitcaseRolling,
	filter : faFilter,
	disabled : faLock,
	ellipsis : faEllipsisV,
	eye: faEye,
	times: faTimes,
	dollar : faDollar
}

const Icon = ({ icon, size, color, aria_label, display, click }: IconProps) => {
	const resolvedIcon = Mapping[icon as keyof typeof Mapping] || null

	if (!resolvedIcon) {
		console.warn(`El icono "${icon}" no existe en el mapeo.`)
	}

	return resolvedIcon ? (
		<FontAwesomeIcon
			icon={resolvedIcon}
			size={size}
			style={{ color, display }}
			aria-label={aria_label}
			cursor='pointer'
			onClick={click}
		/>
	) : null
}

export default Icon
